import { Formik } from "formik";
import React from "react";
import { Modal } from "react-bootstrap";

export default function GenerateMemoModal({
  show,
  onHide,
  title,
  onClick,
  initialValues
}) {
  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={values => onClick(values)}
      >
        {({ setFieldValue, values, handleSubmit }) => (
          <Modal
            size="md"
            show={show}
            centered
            onHide={onHide}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-lg">
                {title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group row">
                <div className="col">
                  <label>
                    <strong>Nama File</strong>
                  </label>
                  <input
                    name="filename"
                    className="form-control"
                    placeholder="Memo PPD Lembaga 2022/08"
                    value={values.filename}
                    onChange={e => {
                      const value = e.target.value || null;
                      setFieldValue(e.target.name, value);
                    }}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div>
                <button
                  type="button"
                  onClick={onHide}
                  className="btn btn-light btn-elevate"
                >
                  Cancel
                </button>
                <> </>
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="btn btn-primary btn-elevate"
                >
                  Generate
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>
    </div>
  );
}
